/*
 * @Description:接口
 * @Autor: zczhang
 * @Date: 2021-03-16 10:15:39
 * @LastEditors: zczhang
 * @LastEditTime: 2021-03-16 18:17:16
 */
import { post } from "@/api/requrestHttp"
const postQuestionUrl = "/ypt/admin/evaluationContent/info/insert"
const updateQuestionUrl = "/ypt/admin/evaluationContent/info/update"
const getDataUrl = "/jjyl/admin/zfpgdContent/info/findListbyOld"
const getDataUrl1 = "/jjyl/admin/zfpgdContent/info/findListbyOld"
const getQuestionListUrl = "/ypt/admin/evaluationContent/info/findList"
const getDataOfPersonInfoUrl = "/sqyl/admin/customer/info/findById"
const postDataOfInfoBack1Url = "/ypt/admin/order/addWorkInformation"
const postDataOfInfoBack1Ur2 = "/ypt/admin/order/visitRecord"
const postQuestion = data => post(postQuestionUrl, data)
const getData = data => post(getDataUrl, data)
const getQuestionList = data => post(getQuestionListUrl, data)
const updateQuestion = data => post(updateQuestionUrl, data)
const getDataOfPersonInfo = data => post(getDataOfPersonInfoUrl, data)
const postDataOfInfoBack1 = data => post(postDataOfInfoBack1Url, data)
const postDataOfInfoBack2 = data => post(postDataOfInfoBack1Ur2, data)

export {
  postQuestion,
  getData,
  getQuestionList,
  updateQuestion,
  getDataOfPersonInfo,
  postDataOfInfoBack2,
  postDataOfInfoBack1
}
